import PropTypes from 'prop-types';
import React from 'react';

/**
 *  Render "Sponsored" as inline SVG in order to avoid ad blockers
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function SponsoredText(_ref) {
  let {
    className = 'text-size-100',
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    ...rest,
    children: "Sponsored"
  });
}
export default SponsoredText;